<template>
    <paper class="wrm-abnormal-assess">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="装卸" name="loadUnlaod">
                <LoadUnloadPane :isSupplier="isSupplier" />
            </el-tab-pane>
            <el-tab-pane v-if="!isSupplier" label="设备类" name="device">
                <DevicePane />
            </el-tab-pane>
        </el-tabs>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import LoadUnloadPane from './LoadUnloadPane.vue';
import DevicePane from './DevicePane.vue';
// import dayjs from 'dayjs'
// import bigDataLog from '@/utils/bigDataLog'
// import mPane from '@/components/supplierPanel';
// import ScoreEditDialog from './ScoreEditDialog.vue' 
// import RecordDialog from './RecordDialog.vue' 
// import Preview from '../../../components/viewAttachment.vue';
// import config from './loadUnloadConfig.js';
// import { dictWithUrl } from '@/components/lots/api';
// import { getPerformanceList, exportPerformance, deprecatePerformance, confirmPerformance, recalculatePerformance } from '../../../api/warehouseResourceManagement/performanceAssessDetail.js';
// import { AUDIT_STATUS } from '../../../constant/constant.js';
// import { mapState } from 'vuex';
export default {
    components: { paper, LoadUnloadPane, DevicePane },
    data() {
        return {
            activeName: 'loadUnlaod'
        }
    },
    computed: {
        isSupplier() {
            return !!this.$store.state.supplier
        },
    },
    methods: {
      handleClick(tab, event) {
        // console.log(tab, event);
      }
    },
}
</script>